<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';

const presentation = usePresentation();

</script>

<template>

    <div class="pl-10">
            
        <h1 class="text-xl 2xl:text-2xl font-semibold mb-6 -ml-14 flex items-center gap-2">
            <IconButton name="arrow-left" 
                class="text-2xl"
                @click="() => presentation.currentTrigger = -1"
            />
            Stand Out Features
        </h1>
        <ul class="list-disc flex flex-col gap-4 text-lg 2xl:text-xl">
            <li>
                Available for <span class="text-cyan-400 font-semibold">NEW</span> and <span class="text-cyan-400 font-semibold">DEMO</span> vehicles
            </li>
            <li>
                Compliments the OEM Warranty
            </li>
            <li>
                Compliments OEM Capped Price Service plans
            </li>
            <li>
                <span class="text-cyan-400 font-semibold">No setup or ongoing fees</span>, pure profit to the dealership
            </li>
            <li>
                <span class="text-cyan-400 font-semibold">Minimum £315 upfront margin</span>, plus ongoing revenue from the repairs
            </li>
        </ul>

    </div>

</template>